import { render, staticRenderFns } from "./PosicaoFrete.vue?vue&type=template&id=a150c64a"
import script from "./PosicaoFrete.vue?vue&type=script&lang=js"
export * from "./PosicaoFrete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports